import { Component, OnInit, Input } from '@angular/core';
import { ResidentialService } from '../../residential.service';
import { _ } from 'underscore';
import * as $ from 'jquery';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';

@Component({
  selector: 'app-r-q14',
  templateUrl: './r-q14.component.html',
  styleUrls: ['./r-q14.component.css', '../residential-question.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' }))
      ])
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' }))
      ])
    ])
  ]
})
export class RQ14Component implements OnInit {
  @Input() data: any;
  question;
  questions;
  userResponses = [];
  index;
  questionObj;
  adults;
  children;
  household_people;
  hgAdults = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '10+'];
  hgChildren = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '10+'];
  property;
  messagetype;
  deviceWidth;
  user_bot;
  time = 2000;
  showTyping = false;
  showbutton = true;
  timer;
  typingTimer;
  
  question_q1;
  isRenewal = false;
  showTip;

  constructor(private residentialService: ResidentialService) {
    this.questions = this.residentialService.getQues();
    this.userResponses = this.residentialService.userResponse.userResponses;
    this.property = this.residentialService.property;
    // For setting default value for dropdown
    // this.adults = this.hgAdults[0];
    // this.children = this.hgChildren[0];
    this.deviceWidth = this.residentialService.deviceWidth;
  }

  ngOnInit() {
    this.residentialService.currentId = this.data;
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        if (this.residentialService.service === 'New Service') {
          this.question = this.questions[i].res_question_ns;
        } else {
          this.question = this.questions[i].res_question;
        }
        if (!_.isEmpty(this.property)) {
          if (this.property === 'Apartment or condominium') {
            this.question = this.question.replace('home', 'apartment');
          }
        }
        if (this.deviceWidth > 768) {
          const splitQuestion = this.question.split('occupy ');
          this.question = splitQuestion[0] + 'occupy';
          this.question_q1 = splitQuestion[1];
        }
        this.questionObj = this.questions[i];
        // If the flow is from renewal -> show 'renewal_question' text
        if (this.residentialService.questionFlowType === 'renewal') {
          this.question = this.questions[i].renewal_question;
          this.residentialService.userResponse.userResponses.push(this.residentialService.serviceResObj);
          this.isRenewal = true;
        }
        this.index = i;
      }
    }
    // to set the username dynamically for renewal flow
    // to get the user name from login user obj
    const userObj = JSON.parse(sessionStorage.getItem('userObj'));
    let questionName = !_.isEmpty(this.userResponses[0]) ? this.userResponses[0].fieldValue.toString().replace(/\s+$/, '' ) : '';
    if (!_.isEmpty(userObj)) {
      questionName = userObj['userName'] ? this.titleCase(userObj['userName']) : '';
    }
    this.question = this.question.replace('[first name]', (this.titleCase(questionName)));

    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'res_question_id': this.questionObj._id });
      if (!_.isEmpty(obj)) {
        this.adults = obj.fieldValue.adults;
        this.children = obj.fieldValue.children;
        if (!_.isEmpty(this.adults) && !_.isEmpty(this.children)) {
          this.user_bot = true;
          if (this.deviceWidth < 768) {
            this.showTyping = true;
            setTimeout(() => {
              this.showTyping = false;
              this.next();
            }, this.time);
          }
        }
        // if (this.deviceWidth < 768) {
        //   this.next();
        // }
      }
    }
    this.messagetype = this.residentialService.messervicetype;

    if (_.isEmpty(this.children) && _.isEmpty(this.adults))
    {
      this.showbutton = false;
    }


    if(this.deviceWidth < 768)
    {
      setTimeout(function(){

        $('ng-select:visible').find('.ng-input').find('input').on('focus', function() { $(this).blur(); });
  
      },500)
    }

  }
  titleCase(str) {
    str = str.toLowerCase().split(' ');
    for (let i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(' ');
  }
  getAdults(event) {
    this.adults = event;
    if (this.deviceWidth < 768) {
      this.residentialService.unSelectService({'currentId': this.data});
    }
    this.time  = 2000;
    if (!_.isEmpty(this.adults) && (Number(this.adults) > Number(this.residentialService.adults)) ) {
      this.showTip = true;
    } else {
      this.showTip = false;
    }
    if (!_.isEmpty(this.adults) && !_.isEmpty(this.children)) {
      this.save();
      this.user_bot = true;
      this.goNext();

      if (this.deviceWidth < 768) {
      }else
      {
        if(!this.showbutton)
        {
          this.next();
        }
      }
    }
  }
  getChildren(event) {
    this.children = event;
    if (this.deviceWidth < 768) {
      this.residentialService.unSelectService({'currentId': this.data});
    }
    this.time  = 2000;
    if (!_.isEmpty(this.children) && (Number(this.children) > Number(this.residentialService.childrens)) ) {
      this.showTip = true;
    } else {
      this.showTip = false;
    }
    if (!_.isEmpty(this.adults) && !_.isEmpty(this.children)) {
      this.save();
      this.user_bot = true;
      this.goNext();

      if (this.deviceWidth < 768) {
      }else
      {
        if(!this.showbutton)
        {
          this.next();
        }
      }
    }
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      if (this.typingTimer) {
        clearTimeout(this.typingTimer);
this.showTyping = false;
      }
      this.typingTimer = setTimeout(() => {
        this.showTyping = true;
      }, 250);
      this.timer = setTimeout(() => {
        // // console.log.log(this.time);
        this.showTyping = false;
        this.next();
      }, 0);
    }
  }

  next() {
    if (this.adults === '' || this.adults === null || this.adults === undefined ||
      this.children === '' || this.children === null || this.children === undefined) {
      // console.log.log('adults:', this.adults, 'children:', this.children);
    } else {
      this.save();
      this.user_bot = true;
      this.residentialService.messageService({ 'currentId': this.data });
    }
  }
  // This function is used for to save the data in DB
  save() {
    const Obj = {
      'res_question_id': this.data,
      'fieldName': 'household_people',
      'fieldValue': { 'adults': this.adults, 'children': this.children }
    };
    this.residentialService.updateResponses(Obj);
  }

}
